import Dot from '../Dot';
3;
interface IGreenDot {
  size?: number;
}

const GreenDot = ({ size }: IGreenDot) => {
  return <Dot color="semanticGreen" size={size} />;
};

export default GreenDot;
